import './Features.css';

import { useState, useEffect, useRef } from 'react';

const Features = () => {
  const words = ['brainer', 'confusion', 'hidden fees', 'surprises', 'hassle', 'complexity', 'waiting', 'frustration', 'uncertainty', 'complications'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayedWords, setDisplayedWords] = useState([]);
  const animationInProgress = useRef(false);
  const animationTimeoutRef = useRef(null);

  // Calculate indices for all 5 positions
  const beforePrevIndex = (currentIndex - 2 + words.length) % words.length;
  const prevIndex = (currentIndex - 1 + words.length) % words.length;
  const nextIndex = (currentIndex + 1) % words.length;
  const afterNextIndex = (currentIndex + 2) % words.length;

  // Update displayed words whenever currentIndex changes
  useEffect(() => {
    setDisplayedWords([
      words[beforePrevIndex],
      words[prevIndex],
      words[currentIndex],
      words[nextIndex],
      words[afterNextIndex]
    ]);
  }, [currentIndex, beforePrevIndex, prevIndex, nextIndex, afterNextIndex]);

  // Clean up timeouts on unmount
  useEffect(() => {
    return () => {
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (animationInProgress.current) return;
      
      animationInProgress.current = true;
      // Start transition
      setIsTransitioning(true);
      
      // After animation completes, update the word and reset transition state
      animationTimeoutRef.current = setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
        
        // Small delay before removing the transitioning class to prevent extra animation
        animationTimeoutRef.current = setTimeout(() => {
          setIsTransitioning(false);
          animationInProgress.current = false;
        }, 1);
      }, 500); // Match this with the animation duration in CSS
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="features-container">
      <div className="cycling-text">
        <span className="static-text">No</span>
        <div className="cycling-words">
          <div className="cycling-words-container">
            <div className={`cycling-word before-prev ${isTransitioning ? 'transitioning' : ''}`}>
              {displayedWords[0]}
            </div>
            <div className={`cycling-word prev ${isTransitioning ? 'transitioning' : ''}`}>
              {displayedWords[1]}
            </div>
            <div className={`cycling-word active ${isTransitioning ? 'transitioning' : ''}`}>
              {displayedWords[2]}
            </div>
            <div className={`cycling-word next ${isTransitioning ? 'transitioning' : ''}`}>
              {displayedWords[3]}
            </div>
            <div className={`cycling-word after-next ${isTransitioning ? 'transitioning' : ''}`}>
              {displayedWords[4]}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
